import React, { useEffect, useState, useRef } from 'react';
import CardSecondaryAction from '../../ui-component/cards/CardSecondaryAction';
import MainCard from '../../ui-component/cards/MainCard';
import { Grid } from '@mui/material';
import { gridSpacing } from '../../store/constant';
import { Label, Tooltip } from 'reactstrap';
import axiosInstance from '../../axiosInstance';
import { useSelector } from 'react-redux';
import configData from '../../config';
import uploadCloud from '../../assets/images/icons/cloud-upload-svgrepo-com.svg';
import * as XLSX from 'xlsx';

const BillOfMaterial = () => {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [fileInputKey, setFileInputKey] = useState(0);
    const [selectedFile, setSelectedFile] = useState(null);

    const org_id = useSelector((state) => (state?.account?.org?.id ? state?.account?.org?.id : state?.account?.org_data?.data?.id));

    const handleFileChange = async (file) => {
        console.log(file);

        const fileExtension = getFileExtension(file.name);
        console.log(fileExtension);
        if (isValidFileExtension(fileExtension)) {
            setSelectedFile(file);
            setFileInputKey(prevKey => prevKey + 1);
            // handleUpload(file);
        } else {
            // Invalid file format
            alert('Invalid file format. Please select a CSV, XLSX, or XLS file.');
        }
        // setSelectedFile(file)
    };

    const getFileExtension = (filename) => {
        return filename.split('.').pop().toLowerCase();
    };

    const isValidFileExtension = (extension) => {
        const allowedExtensions = ['csv', 'xlsx', 'xls'];
        return allowedExtensions.includes(extension);
    };

    const fileInputRef = useRef(null);

    const handleUpload = async () => {
        console.log('in handle upload');
        if (selectedFile) {
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('org_id', org_id);
            
            const response = await axiosInstance.post('https://api.projectivetech.com/account/import_bill_of_materials',formData);
            //const response = await axiosInstance.post('http://127.0.0.1:8000/account/import_bill_of_materials',formData);

            setSelectedFile(null);
            console.log(response);
            alert('Trial Balance successfully uploaded.');
            fileInputRef.current.value = '';
        } else {
            alert('Please upload file in appropriate format.');
        }
    };

    useEffect(() => {
        if (selectedFile) handleUpload();
    }, [selectedFile]);
    
    return (
        <React.Fragment>
            <MainCard style={{ color: ' ' }} title="Import Bill of Materials" secondary={<CardSecondaryAction />}>
                <Grid container spacing={gridSpacing} style={{ padding: '0px' }}>
                    <Grid item lg={12} sm={12} md={12}>
                        <div className="uploadMainOpening">
                            <div className="uploadOpening">
                                <img className="uploadCloud" src={uploadCloud} alt="" />
                                <Label>Upload Bill of Materials</Label>
                                <div style={{ padding: '0 10px' }}>
                                    <Label
                                        onClick={() => document.getElementById('hiddenFileInput1').click()}
                                        id="chooseFileButton"
                                        className="chooseFileBtn1"
                                        style={{
                                            cursor: 'pointer',
                                            color: 'white',
                                            background: '#2196f3',
                                            borderRadius: '4px',
                                            padding: '5.5px 13px'
                                        }}
                                    >
                                        Choose File
                                    </Label>
                                    
                                </div>

                                <input
                                    // name="resultUpload"
                                    key={fileInputKey}
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    id="hiddenFileInput1"
                                    onChange={(event) => handleFileChange(event.target.files[0])}
                                />
                                <div style={{ display: 'flex' }}>
                                    <span style={{ fontSize: '12.7px', fontWeight: '400' }}>Maximum File Size: 5 MB </span>
                                    <span style={{ fontSize: '17px', margin: '-6px 3px 0 3px' }}>|</span>
                                    <span style={{ fontSize: '12.7px', fontWeight: '400' }}> File Format: CSV or TSV or XLS</span>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </MainCard>
            <Grid item xs={12} className="sub_div">
                <Grid container spacing={gridSpacing}>
                    <Grid item lg={12} md={6} sm={6} xs={12}>
                        <Grid className="col-12 col-sm-12 text-center footer_inner_div">&copy; {new Date().getFullYear()} IMAGE-I</Grid>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default BillOfMaterial;
